import UserList, { Candidate } from '~/components/UserList';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Clear from '@mui/icons-material/Clear';
import messages from '../messages';

type AssignedPublishersProps = {
  assignedCandidates: Candidate[];
  onRemoveCandidateAssignment: (applicationId: number) => void;
  onRemoveAllAssignments: () => void;
  onSetPublisherAsLead: (applicationId: number) => void;
};

const sortCandidatesToPutLeadFirst = (candidates: Candidate[]) =>
  candidates.sort((candidate) => (candidate.assignment?.isLead ? -1 : 0));

const AssignedPublishers = (props: AssignedPublishersProps) => {
  const intl = useIntl();
  return props.assignedCandidates ? (
    <UserList
      isCollapsible={false}
      isOpen
      onToggle={() => {}}
      renderHeaderItemAction={() =>
        props.assignedCandidates.length > 0 ? (
          <Button onClick={props.onRemoveAllAssignments}>
            <FormattedMessage {...messages.unassignAllPublishers} />
          </Button>
        ) : null
      }
      renderListItemAction={(candidate) => (
        <IconButton
          onClick={() =>
            props.onRemoveCandidateAssignment(candidate.application.id)
          }
          size="large"
          aria-label={intl.formatMessage(messages.removePublisherAssignment, {
            firstName: candidate.application.publisher.firstName,
            lastName: candidate.application.publisher.lastName,
          })}
        >
          <Clear />
        </IconButton>
      )}
      setPublisherAsLead={(candidate) =>
        props.onSetPublisherAsLead(candidate.application.id)
      }
      candidates={sortCandidatesToPutLeadFirst(props.assignedCandidates)}
      title={<FormattedMessage {...messages.assignments} />}
    />
  ) : null;
};

export default AssignedPublishers;
